import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { formatAsGermanDate } from '~/functions/helpers';
import { impactResultCardEditPath } from '~/functions/impact-result-card-edit';
import { renderMarkdown } from '~/functions/markdown';
import { getStrategyChangedFieldKeys } from '~/functions/review-snapshot-diff';
export default /*#__PURE__*/_defineComponent({
  __name: 'ImpactStrategyResults',
  props: {
    tocImpact: null,
    ventureId: null,
    readOnly: {
      type: Boolean
    },
    exportLayout: {
      type: Boolean
    },
    compareImpact: null,
    compareToLive: {
      type: Boolean
    },
    compareReviewTimeIsDisplay: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var STRATEGY_FIELD_KEYS = ['companyVision', 'problemStatement', 'targetGroup', 'inputsActivities', 'solutionsOutput', 'shortTermOutcomes', 'longTermImpacts', 'riskReboundEffects'];
    var editPath = computed(function () {
      return props.ventureId ? impactResultCardEditPath(props.ventureId, props.tocImpact) : null;
    });
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var exportLayout = computed(function () {
      return props.exportLayout === true;
    });
    var sectionPaddingClass = computed(function () {
      return exportLayout.value ? 'pa-4' : 'pa-4 pa-md-5';
    });
    var strategyOverviewGridClass = computed(function () {
      return exportLayout.value ? 'grid grid-cols-2 gap-2 w-full' : 'grid grid-cols-1 md:grid-cols-2 gap-3';
    });
    var strategyOverviewWideColClass = computed(function () {
      return exportLayout.value ? 'col-span-2' : 'md:col-span-2';
    });

    /** Export: 4 equal columns edge-to-edge; in-app: flex row + arrows. */
    var tocStepsRowClass = computed(function () {
      return exportLayout.value ? 'grid grid-cols-4 gap-2 w-full' : 'flex flex-col md:flex-row md:items-stretch w-full';
    });
    var tocStepArrowDesktopClass = 'hidden md:flex items-center px-1 text-xl leading-none grey--text text--lighten-1';
    var tocImpact = computed(function () {
      return props.tocImpact;
    });
    var reviewTimeImpact = computed(function () {
      if (!props.compareToLive || !props.compareImpact) return null;
      return props.compareReviewTimeIsDisplay ? props.tocImpact : props.compareImpact;
    });
    var currentImpact = computed(function () {
      if (!props.compareToLive || !props.compareImpact) return null;
      return props.compareReviewTimeIsDisplay ? props.compareImpact : props.tocImpact;
    });
    var changedFieldKeys = computed(function () {
      if (!reviewTimeImpact.value || !currentImpact.value) {
        return new Set();
      }
      return getStrategyChangedFieldKeys(reviewTimeImpact.value, currentImpact.value);
    });
    var TOC_STEP_FIELD_KEYS = {
      inputs: 'inputsActivities',
      outputs: 'solutionsOutput',
      outcomes: 'shortTermOutcomes',
      impact: 'longTermImpacts'
    };
    function showFieldDiff(fieldKey) {
      var _TOC_STEP_FIELD_KEYS$;
      var strategyKey = (_TOC_STEP_FIELD_KEYS$ = TOC_STEP_FIELD_KEYS[fieldKey]) !== null && _TOC_STEP_FIELD_KEYS$ !== void 0 ? _TOC_STEP_FIELD_KEYS$ : fieldKey;
      return changedFieldKeys.value.has(strategyKey);
    }
    function reviewTimeFieldValue(fieldKey) {
      var _TOC_STEP_FIELD_KEYS$2, _reviewTimeImpact$val, _reviewTimeImpact$val2;
      var strategyKey = (_TOC_STEP_FIELD_KEYS$2 = TOC_STEP_FIELD_KEYS[fieldKey]) !== null && _TOC_STEP_FIELD_KEYS$2 !== void 0 ? _TOC_STEP_FIELD_KEYS$2 : fieldKey;
      return (_reviewTimeImpact$val = (_reviewTimeImpact$val2 = reviewTimeImpact.value) === null || _reviewTimeImpact$val2 === void 0 ? void 0 : _reviewTimeImpact$val2[strategyKey]) !== null && _reviewTimeImpact$val !== void 0 ? _reviewTimeImpact$val : null;
    }
    function currentFieldValue(fieldKey) {
      var _TOC_STEP_FIELD_KEYS$3, _currentImpact$value$, _currentImpact$value;
      var strategyKey = (_TOC_STEP_FIELD_KEYS$3 = TOC_STEP_FIELD_KEYS[fieldKey]) !== null && _TOC_STEP_FIELD_KEYS$3 !== void 0 ? _TOC_STEP_FIELD_KEYS$3 : fieldKey;
      return (_currentImpact$value$ = (_currentImpact$value = currentImpact.value) === null || _currentImpact$value === void 0 ? void 0 : _currentImpact$value[strategyKey]) !== null && _currentImpact$value$ !== void 0 ? _currentImpact$value$ : null;
    }
    var strategyOverviewFields = computed(function () {
      var _tocImpact$value, _tocImpact$value2, _tocImpact$value3;
      return [{
        key: 'companyVision',
        label: proxy.$t('companyVision'),
        value: (_tocImpact$value = tocImpact.value) === null || _tocImpact$value === void 0 ? void 0 : _tocImpact$value.companyVision,
        wide: true
      }, {
        key: 'problemStatement',
        label: proxy.$t('problemStatement'),
        value: (_tocImpact$value2 = tocImpact.value) === null || _tocImpact$value2 === void 0 ? void 0 : _tocImpact$value2.problemStatement,
        wide: false
      }, {
        key: 'targetGroup',
        label: proxy.$t('targetGroup'),
        value: (_tocImpact$value3 = tocImpact.value) === null || _tocImpact$value3 === void 0 ? void 0 : _tocImpact$value3.targetGroup,
        wide: false
      }];
    });
    var tocSteps = computed(function () {
      var _tocImpact$value4, _tocImpact$value5, _tocImpact$value6, _tocImpact$value7;
      return [{
        key: 'inputs',
        label: proxy.$t('inputsActivities'),
        value: (_tocImpact$value4 = tocImpact.value) === null || _tocImpact$value4 === void 0 ? void 0 : _tocImpact$value4.inputsActivities,
        borderColor: 'var(--v-primary-base)',
        labelClass: 'primary--text'
      }, {
        key: 'outputs',
        label: proxy.$t('solutionsOutput'),
        value: (_tocImpact$value5 = tocImpact.value) === null || _tocImpact$value5 === void 0 ? void 0 : _tocImpact$value5.solutionsOutput,
        borderColor: 'var(--v-success-base)',
        labelClass: 'success--text'
      }, {
        key: 'outcomes',
        label: proxy.$t('shortTermOutcomes'),
        value: (_tocImpact$value6 = tocImpact.value) === null || _tocImpact$value6 === void 0 ? void 0 : _tocImpact$value6.shortTermOutcomes,
        borderColor: 'var(--v-info-base)',
        labelClass: 'info--text'
      }, {
        key: 'impact',
        label: proxy.$t('longTermImpacts'),
        value: (_tocImpact$value7 = tocImpact.value) === null || _tocImpact$value7 === void 0 ? void 0 : _tocImpact$value7.longTermImpacts,
        borderColor: 'var(--v-headerText-base)',
        labelClass: 'headerText--text'
      }];
    });
    function hasFieldContent(value) {
      if (!value) return false;
      return value.replace(/<[^>]*>/g, '').trim().length > 0;
    }
    var isComplete = computed(function () {
      return STRATEGY_FIELD_KEYS.every(function (key) {
        return hasFieldContent(tocImpact.value[key]);
      });
    });
    var updatedOnLabel = computed(function () {
      var _tocImpact$value8;
      var submitDate = (_tocImpact$value8 = tocImpact.value) === null || _tocImpact$value8 === void 0 ? void 0 : _tocImpact$value8.submitDate;
      if (!submitDate) return null;
      var formatted = formatAsGermanDate(String(submitDate));
      if (!formatted) return null;
      return proxy.$t('updatedOn', {
        date: formatted
      });
    });
    function renderField(value) {
      if (value == null) return '';
      return renderMarkdown(value);
    }
    return {
      __sfc: true,
      STRATEGY_FIELD_KEYS: STRATEGY_FIELD_KEYS,
      props: props,
      editPath: editPath,
      proxy: proxy,
      exportLayout: exportLayout,
      sectionPaddingClass: sectionPaddingClass,
      strategyOverviewGridClass: strategyOverviewGridClass,
      strategyOverviewWideColClass: strategyOverviewWideColClass,
      tocStepsRowClass: tocStepsRowClass,
      tocStepArrowDesktopClass: tocStepArrowDesktopClass,
      tocImpact: tocImpact,
      reviewTimeImpact: reviewTimeImpact,
      currentImpact: currentImpact,
      changedFieldKeys: changedFieldKeys,
      TOC_STEP_FIELD_KEYS: TOC_STEP_FIELD_KEYS,
      showFieldDiff: showFieldDiff,
      reviewTimeFieldValue: reviewTimeFieldValue,
      currentFieldValue: currentFieldValue,
      strategyOverviewFields: strategyOverviewFields,
      tocSteps: tocSteps,
      hasFieldContent: hasFieldContent,
      isComplete: isComplete,
      updatedOnLabel: updatedOnLabel,
      renderField: renderField
    };
  }
});